import axios, { AxiosInstance } from "axios";
import App from "../main"; // import the instance

import { store } from "../store";

class ApiService {

    private static serviceInstance: AxiosInstance;

    public static get instance(): AxiosInstance {
        // If set-up return
        if (this.serviceInstance) {
            return this.serviceInstance;
        } else {
            // Else set-up
            const newInstance = axios.create();
            newInstance.interceptors.request.use((request: any) => {
                (App as any).$Progress.start();
                const authToken = store.getters["userModule/authToken"];

                if (authToken) {
                    request.headers.Authorization = `Bearer ${authToken}`;
                }

                return request;
            }, (err: any) => {
                // fail when an error is received
                (App as any).$Progress.fail();
                return Promise.reject(err);
            });

            return this.serviceInstance = newInstance;
        }
    }
}

// export a singleton instance in the global namespace
export const apiService = ApiService.instance;
